import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMedication = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_10052_25444",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_10052_25444)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M9.1187 14.1667H10.8816V12.0834H12.965V10.3207H10.8816V8.23734H9.1187V10.3207H7.03537V12.0834H9.1187V14.1667ZM6.08995 17.0353C5.67565 17.0353 5.321 16.8878 5.026 16.5928C4.731 16.2978 4.5835 15.9431 4.5835 15.5288V6.87505C4.5835 6.46075 4.731 6.10609 5.026 5.81109C5.321 5.51609 5.67565 5.36859 6.08995 5.36859H13.9104C14.3247 5.36859 14.6793 5.51609 14.9743 5.81109C15.2693 6.10609 15.4168 6.46075 15.4168 6.87505V15.5288C15.4168 15.9431 15.2693 16.2978 14.9743 16.5928C14.6793 16.8878 14.3247 17.0353 13.9104 17.0353H6.08995ZM6.08995 15.7853H13.9104C13.9745 15.7853 14.0333 15.7586 14.0866 15.7053C14.1401 15.6518 14.1668 15.593 14.1668 15.5288V6.87505C14.1668 6.81102 14.1401 6.75227 14.0866 6.6988C14.0333 6.64533 13.9745 6.61859 13.9104 6.61859H6.08995C6.02579 6.61859 5.96704 6.64533 5.9137 6.6988C5.86023 6.75227 5.8335 6.81102 5.8335 6.87505V15.5288C5.8335 15.593 5.86023 15.6518 5.9137 15.7053C5.96704 15.7586 6.02579 15.7853 6.08995 15.7853ZM5.19245 4.21484V2.96484H14.8079V4.21484H5.19245Z",
			fill: "currentColor"
		})
	})]
});
export default SvgMedication;
